"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconType = void 0;
var react_1 = __importDefault(require("react"));
var PaginationIcon = function (props) {
    var getRootElement = function (children) {
        switch (props.rootElement) {
            case "Div":
                return react_1.default.createElement("div", { className: props.rootElementClassName }, children);
            case "Span":
                return react_1.default.createElement("span", { className: props.rootElementClassName }, children);
        }
    };
    var getSize = function () {
        switch (props.size) {
            case "Small":
                return "16px";
            case "Medium":
                return "24px";
            case "Large":
                return "32px";
            case "X-Large":
                return "40px";
            case "XX-Large":
                return "48px";
        }
    };
    var getIcon = function () {
        switch (props.icon) {
            case IconType.Next:
                return (react_1.default.createElement("svg", { className: props.className, onClick: props.onClick, width: getSize(), height: getSize(), version: "1.1", viewBox: "0 0 700 700", xmlns: "http://www.w3.org/2000/svg" },
                    react_1.default.createElement("path", { fill: "currentColor", d: "m150.47 558.49c1.9219 0.99219 4.0508 1.5117 6.2148 1.5117 2.6992-0.003906 5.3359-0.82422 7.5586-2.3516l386.68-266.45c3.6094-2.4883 5.7656-6.5898 5.7656-10.977 0-4.3828-2.1562-8.4883-5.7656-10.977l-386.68-266.89c-4.1172-2.8203-9.4688-3.1133-13.871-0.75781s-7.1289 6.9648-7.0703 11.957v533.12c0 4.9648 2.7617 9.5195 7.168 11.816z" })));
            case IconType.Previous:
                return (react_1.default.createElement("svg", { className: props.className, onClick: props.onClick, width: getSize(), height: getSize(), version: "1.1", viewBox: "0 0 700 700", xmlns: "http://www.w3.org/2000/svg" },
                    react_1.default.createElement("path", { fill: "currentColor", d: "m549.36 558.32c-1.6797 1.1211-3.9219 1.6797-6.1602 1.6797-2.8008 0-5.0391-0.55859-7.8398-2.2383l-386.4-266.56c-3.3594-2.2383-5.6016-6.7188-5.6016-11.199s2.2383-8.3984 5.6016-11.199l386.4-266.56c3.9219-2.8008 9.5195-3.3594 14-0.55859 4.4805 2.2383 7.2812 6.7188 7.2812 11.762v533.12c0 5.0352-2.8008 9.5117-7.2812 11.754z" })));
        }
    };
    return react_1.default.createElement(react_1.default.Fragment, null, getRootElement(getIcon()));
};
exports.default = PaginationIcon;
// eslint-disable-next-line no-shadow
var IconType;
(function (IconType) {
    IconType["Next"] = "Next";
    IconType["Previous"] = "Previous";
})(IconType = exports.IconType || (exports.IconType = {}));
